export { PopoverDirective } from './popover.directive';
export { PopoverModule } from './popover.module';
export { PopoverConfig } from './popover.config';
export { PopoverContainerComponent } from './popover-container.component';



// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/popover/index.ts